import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { NotificationDetailsService } from './notification-detatils.service';
@Component({
    selector: 'app-notification-details',
    templateUrl: './notification-details.component.html',
    styleUrls: ['./notification-details.component.scss']
})
export class NotificationDetailsComponent implements OnInit {

    notification;
    templateId;
    data;
    formEditable = true;        
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _notificationDetailsService: NotificationDetailsService,
        private _router : Router,
    ) { }
    ngOnInit() {
        if(this._activatedRoute.snapshot.queryParams['notesId']){
            this._notificationDetailsService.getById(this._activatedRoute.snapshot.queryParams['notesId'])
            .subscribe((result: any) => {
                this.notification = result.data;
                console.log('​SubmittedFormPreviewComponent -> ngOnInit -> this.submittedForm', result);
            }, (err) => {
                console.log('​SubmittedFormPreviewComponent -> ngOnInit -> ', err);
            });
        }else{
            this._notificationDetailsService.getSubmittedFormPreviewHtml(this._activatedRoute.snapshot.queryParams['taskId']).subscribe(
                (res:any)=>{
                    this.templateId = res.data.dbTask.template._id;
                    this.data = res.data.dbTask.data.data
                }
            )
        }
    }
    redirectNotification(){
        this._router.navigateByUrl('/notifications');
    }
}



// WEBPACK FOOTER //
// ./src/app/notification-details/notification-details.component.ts